export default __webpack_public_path__ + "static/DemoReel-454cd49abc8677a061e0f9ed0e977c6b.png";